export * from './region';
export * from './polyregion';
export * from './shape';



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/shape/index.js
 **/